import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  Box,
  Checkbox,
  FormControlLabel,
} from "@mui/material";
import PublishIcon from "@mui/icons-material/Publish";
import Langs from "../../../app/lang/langs";
import { showErrorToast, checkPermission } from "../../../app/utils/helpers";
import { submitShifts, getPlanning } from "../planningSlice";
import { setIsLoading } from "../../common/commonSlice";
import { config } from "../../../app/utils/config";

export function MobilePublishModal({ show, onHide }) {
  const dispatch = useDispatch();

  const selectedTeamsIds = useSelector((state) => state.teams.selectedTeamsIds);
  const selectedDate = useSelector((state) => state.planning.selectedDate);
  const collabs = useSelector((state) => state.collabs.list);

  const [notifyCollabs, setNotifyCollabs] = useState(true);

  function isManager(teamId) {
    return checkPermission(
      config.scopes.shifts,
      config.permissionTypes.edit,
      teamId
    );
  }

  function handlePublish() {
    onHide();
    dispatch(setIsLoading(true));

    dispatch(
      submitShifts({
        teamIds: selectedTeamsIds.filter((id) => isManager(id)),
        date: selectedDate,
        notify: notifyCollabs,
      })
    ).then((response) => {
      dispatch(setIsLoading(false));
      if (response["payload"]["responseData"]) {
        loadPlanning();
      }
      if (response["payload"]["responseError"]) {
        showErrorToast();
      }
    });
  }

  function loadPlanning() {
    if (selectedTeamsIds && selectedTeamsIds.length && collabs.length) {
      let selectedCollabsIds = collabs.reduce((array, current) => {
        array.push(current.id);
        return array;
      }, []);
      dispatch(getPlanning({ selectedTeamsIds, selectedCollabsIds }));
    }
  }

  return (
    <Dialog
      open={show}
      onClose={onHide}
      fullWidth
      maxWidth="xs"
      sx={{ zIndex: 1400 }}
      PaperProps={{
        sx: {
          borderRadius: "16px",
          mx: 2,
        },
      }}
    >
      <DialogTitle
        sx={{
          display: "flex",
          alignItems: "center",
          gap: 1,
          pb: 1,
        }}
      >
        <PublishIcon sx={{ color: "#FF9015", fontSize: 28 }} />
        <Typography variant="h6" component="span" sx={{ fontWeight: 600 }}>
          <Langs str="PUBLISH" />
        </Typography>
      </DialogTitle>

      <DialogContent>
        <Typography variant="body1" sx={{ pb: 2 }}>
          <Langs str="PUBLISH_CONFIRMATION" />
        </Typography>

        <FormControlLabel
          control={
            <Checkbox
              checked={notifyCollabs}
              onChange={(e) => setNotifyCollabs(e.target.checked)}
              sx={{
                color: "#FF9015",
                "&.Mui-checked": { color: "#FF9015" },
              }}
            />
          }
          label={
            <Typography variant="body2">
              <Langs str="NOTIFY_COLLABS" />
            </Typography>
          }
        />
      </DialogContent>

      <DialogActions sx={{ px: 3, pb: 2, gap: 1 }}>
        <Button
          variant="outlined"
          onClick={onHide}
          sx={{
            flex: 1,
            borderRadius: "999px",
            minHeight: 48,
            textTransform: "none",
            fontWeight: 600,
            color: "text.secondary",
            borderColor: "divider",
          }}
        >
          <Langs str="CANCEL" />
        </Button>
        <Button
          variant="contained"
          onClick={handlePublish}
          sx={{
            flex: 1,
            borderRadius: "999px",
            minHeight: 48,
            textTransform: "none",
            fontWeight: 600,
            backgroundColor: "#FF9015",
            "&:hover": { backgroundColor: "#e6820d" },
            "&:active": { transform: "scale(0.97)" },
          }}
        >
          <Langs str="PUBLISH" />
        </Button>
      </DialogActions>
    </Dialog>
  );
}
